import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import FeatureItem from 'components/FeatureItem'
import MediaCard from './common/MediaCard'

const features = [
  {
    description:
      'We strictly comply with KYC/AML policies, enforced by a dedicated Compliance team. We are regulated as a Trust and Service Provider by the HMRC (AML no.12883542).',
    title: 'Regulatory compliance.',
  },
  {
    description:
      'A proven record of successful collaborations with prominent banks such as Tide, ANNA, and other fintech partners. Not to mention our accounting partnerships. All in all, we have securely serviced over 100,000 customers to date without incident.',
    title: 'Fintech partnership.',
  },
  {
    description:
      'We are audited regularly, maintain certifications, provide industry-standard protections (ICO no. ZA041914).',
    title: 'Data Protection.',
  },
  {
    description:
      'Our Cyber Essentials and Cyber Essentials Plus certifications highlight our commitment to cybersecurity.',
    title: 'Uncompromised Security.',
  },
  {
    description:
      'Ready to provide sample commercial agreement, T&Cs, Business Continuity Plan, Data protection policies, Customer Support SLA, Complaints Policy, Service Level Agreement, and Proof of ID and address document checklist.',
    title: 'Transparency & Accountability.',
  },
]

type GotYouCoveredCardType = {
  className?: string
}

const GotYouCoveredCard: ReactFC<PropsWithChildren<GotYouCoveredCardType>> = ({
  className = '',
}) => {
  return (
    <MediaCard
      className={className}
      layout={{
        desktop: 'content-left-media-right',
        mobile: 'content-top-media-bottom',
      }}
      imageContainerWidth='50%'
      imageFitPreset='contain-center'
      image={{
        alt: 'HaiRo™ mail service with robot mascot and phone displaying mail interface',
        desktop: {
          dimensions: { height: 820, width: 678 },
          src: '/images/new/robot-mail-preview.png',
        },
        mobile: {
          dimensions: { height: 820, width: 678 },
          src: '/images/new/robot-mail-preview.png',
        },
      }}
    >
      <div className='pt-8 pt-lg-11 ps-4 ps-lg-20 pb-5 pb-lg-17 pe-4 pe-lg-0'>
        <h3 className='fs-fluid-24-32 fw-semibold mb-3 mb-lg-6'>
          You're covered
        </h3>
        <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
          {features.map((feature) => (
            <FeatureItem
              key={feature.title}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </MediaCard>
  )
}

export default GotYouCoveredCard
